import axiosAuth from '../../axiosMain';

async function index() {
  let response = await axiosAuth.get('/statistic');
  return response.data;
}

export default {
  index,
};
